import styled from "styled-components";
import {SearchNoGamesFoundDefaultBox} from "./search-no-games-found.default.box";

export const SearchNoGamesFoundCasino777Box = styled(SearchNoGamesFoundDefaultBox)`
    font-size: 1.6rem;
`;